<template>
  <div>
    <v-menu
      open-on-hover
      bottom offset-y right
      min-width="150"
    >
      <template #activator="{ on }">
        <v-btn
          color="grey200" class="px-3 text-capitalize"
          text :loading="loading" :ripple="false"
          v-on="on"
        >
          <fai :icon="['fas', 'language']" class="text-h5 mr-1 " />
          <span v-show="!iconOnly" class="mr-1" v-text="$t(`locale.${$i18n.locale}`)" />
          <fai :icon="['far', 'angle-down']" />
        </v-btn>
      </template>

      <v-list color="grey600" class="py-0" dense>
        <v-list-item
          v-for="lang in availableLangs"
          :key="lang.code"
          :ripple="false"
          class="lang-item"
          :class="{ active: $i18n.locale === lang.code }"
          @click="onListItemClick(lang.code)"
        >
          <v-list-item-title class="d-flex align-center text--secondary">
            <span class="twf mr-2" :class="`twf-${lang.flag}`" />
            <span class="text-body-2">{{ lang.name }}</span>
          </v-list-item-title>
        </v-list-item>
        <!-- <v-list-item
          class="lang-item"
        >
          <v-list-item-title class="d-flex align-center text--secondary">
            Chill we just launched
          </v-list-item-title>
        </v-list-item> -->
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { TO_FLAG } from '@/utils/i18n'

export default {
  components: {},
  props: {
    loading: Boolean,
    iconOnly: Boolean,
  },
  computed: {
    availableLangs() {
      return this.$i18n.supportedLocales.map(lang => ({
        flag: TO_FLAG[lang] || lang,
        name: this.$t(`locale.${lang}`),
        code: lang,
      }))
    },
  },
  methods: {
    onListItemClick(locale) {
      if (this.$i18n.locale === locale) return

      this.$emit('input', locale)
    },
  },
}
</script>

<style lang="scss" scoped>
.lang-item {
  .twf {
    width: 1.75em;
    height: 1.75em;
    vertical-align: -0.5em;
  }

  &.active .text-body-2 {
    color: grey(100);
  }
}

</style>
